import Page from 'components/Page';
import React, { useEffect, useState } from 'react';
import { Card, Container, CardContent, Grid, Select, FormControl, MenuItem } from '@mui/material';
import Breadcrumbs from 'components/Breadcrumbs';
import RewardHistoryTable from 'components/Admin/Tables/RewardHistoryTable';
import { useBusinessEntityState } from 'state';

const AllRewardHistory = () => {
  const { pools, fetchAllPools } = useBusinessEntityState();
  const [selectedPool, setSelectedPool] = useState('all');

  const handleChange = (event) => {
    setSelectedPool(event.target.value);
    console.log('SELECTED POOL', event.target.value);
  };
  useEffect(() => {
    fetchAllPools();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Page title="XDC Staking">
      <Container sx={{ mt: 2 }}>
        <Grid container spacing={2} alignItems="flex-end" justifyContent="space-between">
          <Grid item xs={8}>
            <Breadcrumbs pageHead="Platform Reward History" />
          </Grid>
          <Grid item xs={4} display="flex" justifyContent="end">
            <FormControl size="small" variant="outlined" fullWidth sx={{ mt: 1.5, width: '325px' }}>
              <Select
                // onChange={handleChange}
                inputProps={{ 'aria-label': 'Without label' }}
                id="token"
                onChange={handleChange}
                value={selectedPool}
              >
                <MenuItem selected key="All" value="all">
                  All
                </MenuItem>
                {pools &&
                  pools.map((pool) => {
                    return (
                      <MenuItem key={pool.name} value={pool.id}>
                        {pool.name}
                      </MenuItem>
                    );
                  })}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Card sx={{ mt: 2 }} className="form-card">
          <CardContent>
            <RewardHistoryTable poolID={selectedPool} />
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
};

export default AllRewardHistory;
